import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <Section emoji="👉" eyebrow="Sound familiar?" title="Do you recognize yourself in any of these situations?" subtitle="If you answer yes to any — this was built for you." dark data-id="element-173" data-mp="2lp53mmtzyurk">
      <ul className="space-y-3" data-id="element-174" data-mp="1xxzpqd7macjw">
        {painPoints.map(point => <li key={point.text} className="flex gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4" data-id="element-175" data-mp="1xzuek2m0eot9">
            <span className="text-xl leading-none" aria-hidden="true" data-id="element-176" data-mp="1o0d99mao6cxt">
              {point.emoji}
            </span>
            <span className="text-[14px] leading-snug text-white/85 sm:text-[15px]" data-id="element-177" data-mp="1szg30al78wqh">
              {point.text}
            </span>
          </li>)}
      </ul>

      <p className="mt-8 text-center font-display text-xl font-bold text-teal-400 sm:text-2xl" data-id="element-178" data-mp="3ncfrkt7k519w">
        You deserve more than that uncertainty.
      </p>

      <div className="mx-auto mt-5 max-w-md" data-id="element-179" data-mp="1yyu7bbuwvzbo">
        <CTAButton label="End the guessing today" variant="light" data-id="element-180" data-mp="1u23q2l7dexoo" />
        <p className="mt-3 text-center text-[11px] font-medium text-white/60" data-id="element-181" data-mp="1tzrb8gwwt3fu">
          Instant download · 7-day guarantee
        </p>
      </div>
    </Section>;
}